export default {
  spaServiceLabel: 'Servicio de spa',
  fitnessClassLabel: 'Clase de fitness',
  selectedTime: 'Hora seleccionada',

  tbd: 'Por determinar',
  durationUnavailable: "Duración no disponible",
  "checkoutCancelled": "Pago cancelado",
  "checkoutCancelledHelp": "El pago pendiente se ha cerrado. Puedes volver y elegir otra opción de pago.",
  "backToBooking": "Volver a la reserva",

  "recoveryCheck": "Comprobar la reserva",
  "recoveryChecking": "Comprobando el resultado…",
  "recoveryExplain": "Comprueba el resultado antes de intentarlo de nuevo. Se cerrará de forma segura cualquier pago pendiente.",
  "recoveryPending": "El resultado sigue pendiente. Compruébalo de nuevo antes de iniciar otra reserva.",
  "recoveryHelp": "El club debe revisar el pago. Contacta con el club antes de reservar de nuevo.",

  "noPayment": "No se requiere pago",
  "spaSuccess": "Tu tratamiento está reservado",
  "fitnessSuccess": "Tu plaza está reservada",
  "racquetSuccess": "Tu pista está reservada",
  "reservationConfirmed": "Reserva confirmada",
  "welcome": "Todo está preparado. Te esperamos.",
  "viewBooking": "Ver reserva",
  "backHome": "Volver al inicio",
  "reference": "Referencia de reserva",
  "paymentLabel": "Pago",
  "confirmed": "Confirmada",
  "guests": "Asistentes",
  "alreadyBooked": "Ya tienes esta cita. Comprueba tus próximas reservas.",
  "popup": "Permite las ventanas emergentes para continuar al pago seguro.",
  "accounting": "No se ha podido finalizar tu reserva. Contacta con el club para obtener ayuda.",
  "fitnessGeneric": "No se ha podido completar la solicitud. Vuelve a intentarlo o contacta con el club.",
  "fitnessAlreadyBooked": "Ya tienes una reserva para esta sesión.",
  "fitnessAccounting": "No se ha podido finalizar tu reserva. Vuelve a intentarlo o contacta con el club.",

  "total": "Total",
  "confirm": "Confirmar reserva",
  "confirming": "Confirmando…",
  "checking": "Comprobando disponibilidad…",
  "chooseTime": "Vuelve y elige una hora disponible.",
  "pending": "Comprueba tu pago o tus próximas reservas antes de iniciar otra reserva.",
  "unknown": "No hemos podido verificar el resultado. Comprueba tus próximas reservas o contacta con el club antes de volver a intentarlo.",
  "unavailable": "Esa hora ya no está disponible. Elige otra.",
  "invalid": "Esa hora ya no está disponible. Vuelve y elige otra.",
  "failed": "No se puede confirmar la reserva en este momento.",
  "previewFailed": "No se puede comprobar esta hora. Vuelve e inténtalo de nuevo.",
  "serviceFailed": "No se puede cargar este tratamiento. Vuelve e inténtalo de nuevo.",
  "backTimes": "Volver a las horas disponibles",
  "backClasses": "Volver a las clases",
  "review": "Revisar y confirmar",
  "attendee": "Asistente",
  "payer": "Pagador",
  "member": "Socio",
  "details": "Detalles de la reserva",
  "class": "Clase",
  "date": "Fecha",
  "time": "Hora",
  "location": "Ubicación",
  "confirmClass": "Confirma tu clase",
  "fitnessBooking": "Reserva de fitness",
  "session": "Sesión",
  "payment": "Método de pago",
  "account": "Cuenta del socio",
  "statement": "Los cargos se añaden a tu estado de cuenta.",
  "secure": "Paga ahora de forma segura.",
  "guestPay": "El invitado pagará",
  "guestLink": "Envía al invitado un enlace de pago seguro. No se carga en tu cuenta."
}
